import { useEffect, useState } from "react";

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll(); // set initial state
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      className={`bg-white text-dark py-2 border-bottom topbar-sticky ${
        scrolled ? "topbar-scrolled" : ""
      }`}
    >
      <div className="container">
        <div className="d-flex align-items-center justify-content-between">
          
          <div className="d-flex align-items-center gap-3 small">
           
            <div className="d-flex align-items-center gap-1">
              <i className="bi bi-geo-alt text-violet" aria-hidden="true" />
              <span className="d-none d-md-inline">Kumasi, Ghana</span>
            </div>
            <a
              href="tel:+233501234567"
              className="d-flex align-items-center gap-1 text-dark text-decoration-none"
            >
              <i className="bi bi-telephone text-violet" aria-hidden="true" />
              <span className="d-none d-md-inline">+233 50 123 4567</span>
            </a>
            <a
              href="mailto:info@myapp.com"
              className="d-flex align-items-center gap-1 text-dark text-decoration-none"
            >
              <i className="bi bi-envelope text-violet" aria-hidden="true" />
              <span className="d-none d-md-inline">info@myapp.com</span>
            </a>
          </div>
          <div className="d-flex align-items-center gap-3">
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noreferrer"
              className="text-violet"
              aria-label="Facebook"
              title="Facebook"
            >
              <i className="bi bi-facebook fs-6" />
            </a>

            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noreferrer"
              className="text-violet"
              aria-label="Instagram"
              title="Instagram"
            >
              <i className="bi bi-instagram fs-6" />
            </a>

            <a
              href="https://www.twitter.com"
              target="_blank"
              rel="noreferrer"
              className="text-violet"
              aria-label="X (Twitter)"
              title="X (Twitter)"
            >
              <i className="bi bi-twitter-x fs-6" />
            </a>

            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="text-violet"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <i className="bi bi-linkedin fs-6" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
